<template>
  <div
    v-for="(panelId, i) in panelIds"
    v-bind="attrs"
    :id="panelId"
    :key="panelId"
    ref="panels"
    role="tabpanel"
    class="tab-panel"
    :aria-labelledby="tabState.tabs.value[i]"
    :hidden="i !== tabState.activeIndex.value"
    :tabindex="focusable && i === tabState.activeIndex.value ? 0 : undefined"
  ></div>

  <Teleport v-if="activePanel" :to="activePanel">
    <slot>
      <RouterView v-if="keepAlive" v-slot="{ Component }">
        <KeepAlive>
          <Component :is="Component" />
        </KeepAlive>
      </RouterView>
      <RouterView v-else />
    </slot>
  </Teleport>
</template>

<script setup>
import { computed, inject, ref, useAttrs } from 'vue'
import { RouterView } from 'vue-router'
import uniqueId from 'lodash/uniqueId'
import { tabKey } from './key'

defineProps({
  focusable: { type: Boolean, default: false },
  keepAlive: { type: Boolean, default: false },
})

const attrs = useAttrs()

const tabState = inject(tabKey)
const panels = ref(null)

const panelIds = tabState.tabs.value.map(() => uniqueId('tab-panel-'))
panelIds.forEach((panelId) => tabState.registerPanel(panelId))

const activePanel = computed(() => panels.value?.[tabState.activeIndex.value])
</script>

<style scoped>
.tab-panel[hidden] {
  display: none !important;
}
</style>
